export const ASSIGN_PACKAGES_REQUEST = 'ASSIGN_PACKAGES_REQUEST'
export const ASSIGN_PACKAGES_SUCCESS = 'ASSIGN_PACKAGES_SUCCESS'
export const ASSIGN_PACKAGES_RESET = 'ASSIGN_PACKAGES_RESET'
export const ASSIGN_PACKAGES_FAIL = 'ASSIGN_PACKAGES_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'